import {AbstractControl, ValidationErrors} from '@angular/forms';

export function streetNumberSpacingValidator(control: AbstractControl): ValidationErrors | null {
  const value = String(control.value ?? '');

  return value === '' || /\S \d/.test(value) ? null : {streetNumberSpacing: true};
}